<template>
    <div class="z-50 fixed w-full menu-overlay top-12 left-0 flex items-center">
        <div class="absolute w-full h-full bg-gray-900 opacity-50"
             @click.self="close"></div>
        <div style="top: 60px;left:20px;" class="fixed bg-white w-11/12 rounded shadow-lg z-50 overflow-y-auto">
            <div class="flex justify-between flex-col items-center">
                <MenuItem link="app" :title="$t('component.menu.search')"></MenuItem>
                <MenuItem link="applications" :title="$t('component.menu.applications')"></MenuItem>
                <MenuItem link="favorites" :title="$t('component.menu.favorites')"></MenuItem>
                <MenuItem link="excluded" :title="$t('component.menu.excluded')"></MenuItem>
                <!-- <MenuItem link="families" :title="$t('component.menu.families')"></MenuItem> -->
                <!-- <MenuItemSeperator></MenuItemSeperator> -->
                <MenuItem link="profile" :title="$t('component.menu.profile')"></MenuItem>
                <MenuItem link="info" :title="$t('component.menu.info')"></MenuItem>
                <MenuItem @select="$router.push({ name:'corona'}).catch(()=>{})" :title="$t('component.menu.corona')"></MenuItem>
                <MenuItem v-if="loggedIn" @select="$store.dispatch('auth/logout').catch(()=>{})" :title="$t('component.menu.logout')"></MenuItem>
                <MenuItem v-else @select="$router.push({name: 'signin', params: {signInModal: true}}).catch(()=>{})" :title="$t('component.menu.signin')"></MenuItem>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    import MenuItem from "@/components/MenuItem";

    export default {
        name: "Menu",
        components: {MenuItem},
        computed: {
          ...mapGetters('auth', {
              'loggedIn': 'loggedIn'
          })
        },
        methods: {
            close() {
                this.$store.commit('app/hideMainMenu');
            }
        }
    }
</script>

<style scoped>
    .menu-overlay {
        height: calc(100% - 3rem);
    }
</style>